// ============================================
// API SERVICE
// ============================================
import { createApiClient, ApiClient } from '@crew-at-sea/api-client';
import { useAuthStore } from '@/store/auth';

let apiClient: ApiClient | null = null;

export function initializeApiClient(): void {
  apiClient = createApiClient({
    baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3001/api/v1',
    timeout: 10000,
    
    getAccessToken: () => {
      let token = useAuthStore.getState().accessToken;
      if (!token) {
        try {
          const stored = localStorage.getItem('seafarer-auth-storage');
          if (stored) {
            const parsed = JSON.parse(stored);
            token = parsed?.state?.accessToken || null;
          }
        } catch (e) {
          console.error(e);
        }
      }
      return token;
    },
    
    getRefreshToken: () => {
      let token = useAuthStore.getState().refreshToken;
      if (!token) {
        try {
          const stored = localStorage.getItem('seafarer-auth-storage');
          if (stored) {
            const parsed = JSON.parse(stored);
            token = parsed?.state?.refreshToken || null;
          }
        } catch (e) {
          console.error(e);
        }
      }
      return token;
    },
    
    onAccessTokenRefreshed: (accessToken, refreshToken) => {
      useAuthStore.getState().setTokens(accessToken, refreshToken);
    },
    
    onUnauthorized: () => {
      // Login/register sayfalarında logout yapma
      const path = window.location.pathname;
      if (path.includes('/login') || path.includes('/register') || 
          path.includes('/forgot-password') || path.includes('/reset-password')) {
        return;
      }
      useAuthStore.getState().logout();
      window.location.href = '/login';
    },
    
    onError: (error) => {
      console.error('API Error:', error);
    },
  });
}

export function getApi(): ApiClient {
  if (!apiClient) {
    initializeApiClient();
  }
  return apiClient!;
}

// Re-export API endpoints
export {
  authApi,
  usersApi,
  companiesApi,
  jobsApi,
  applicationsApi,
  certificatesApi,
  seaServiceApi,
  documentsApi,
  favoritesApi,
  matchingApi,
  reviewsApi,
  notificationsApi,
  careerApi,
  supportApi,
} from '@crew-at-sea/api-client';